import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';
import './OnboardingCard.css';
import { ProjectBrief } from '../ProjectBrief';
import References from '../References';
import FreeCommentForm from '../FreeCommentForm';
import ManagementWay from '../ProjectManagement';
import { DropboxChooser } from '../DropboxChooser';
import { PricingCalculator } from '../PricingCalculator';
import { FreelancerChooser } from '../FreelancerChooser';
import ContactOption from '../ProjectManagement/ContactOption/ContactOption';
import Summary from './../Summary';
import BasicDetails from '../BasicDatails/BasicDetails';

const { REACT_APP_DROPBOX_KEY } = process.env;

export class OnboardingCard extends Component {
  constructor(props) {
    super(props);
    this.cardInput = React.createRef();
  }

  render() {
    const { cardInfo, handleCardSelected } = this.props;

    return !cardInfo.isSpecial
      ? this.renderOnboardingCard(handleCardSelected)
      : this.renderSpecialCard(cardInfo.value);
  }

  renderSpecialCard(card) {
    const {
      references,
      handleAddReference,
      handleDeleteReference,
      handleProjectBriefInput,
      handleProjectUpload,
      handleRemoveUpload,
      isUploadingAttachment,
      isUploadingProjectPicture,
      projectId,
      projectName,
      projectBrief,
      projectPicture,
      projectAttachments,
      handleReferenceInputChange,
      budget,
      minBudget,
      maxBudget,
      recommendedBudget,
      handleBudgetChange,
      onPricingCalculatorMounted,
      handleAddDeadline,
      selectedValue,
      handleShowFreelancerChooserPopup,
      freelancers,
      freelancersPagination,
      handleFetchFreelancers,
      handleFreelancerBookNow,
      handleFreelancerRequestABid,
      handleFreelancerDeleteABid,
      handleFreelancerCardClicked,
      isFetchingFreelancers,
      handleNextStep,
      cardInfo,
      handleGoToSection,
      handleAddContactInfo,
      handleSaveManagementWay,
      handleGoToDashboard,
      handleCardSelected,
      handleFreeCommentInputChange,
      comment,
    } = this.props;

    const referenceCheckboxesColumn1 = ['Colors', 'Style', 'Tone'];

    const referenceCheckboxesColumn2 = ['Music', 'Voiceover', 'Transitions'];

    const referenceCheckboxesColumn3 = ['Setting', 'Pacing', 'Graphic Effects'];

    const specialCards = {
      deadline: () => (
        <BasicDetails
          projectName={projectName}
          handleProjectBriefInput={handleProjectBriefInput}
          handleProjectUpload={handleProjectUpload}
          handleAddDeadline={handleAddDeadline}
          handleRemoveUpload={handleRemoveUpload}
          projectPicture={projectPicture}
          isUploadingProjectPicture={isUploadingProjectPicture}
          deadline={selectedValue[0]}
          handleNextStep={handleNextStep}
          {...cardInfo}
        />
      ),
      dropbox: () => (
        <DropboxChooser
          appKey={REACT_APP_DROPBOX_KEY}
          className="dropbox_custom_class"
          folderselect
          multiselect
          onCancel={() => {}}
          openOnClick={!selectedValue.includes(cardInfo.value)}
          onSuccess={selectedFolders => {
            handleCardSelected(new Event('click'), cardInfo, selectedFolders);
          }}
        >
          {this.renderOnboardingCard(
            selectedValue.includes(cardInfo.value) && handleCardSelected,
          )}
        </DropboxChooser>
      ),
      project_brief: () => (
        <ProjectBrief
          projectName={projectName}
          projectBrief={projectBrief}
          projectPicture={projectPicture}
          projectAttachments={projectAttachments}
          handleProjectBriefInput={handleProjectBriefInput}
          handleProjectUpload={handleProjectUpload}
          handleRemoveUpload={handleRemoveUpload}
          isUploadingAttachment={isUploadingAttachment}
          isUploadingProjectPicture={isUploadingProjectPicture}
        />
      ),
      references_screen: () => (
        <References
          references={references}
          handleAddReference={handleAddReference}
          handleDeleteReference={handleDeleteReference}
          handleReferenceInputChange={handleReferenceInputChange}
          referenceCheckboxesColumn1={referenceCheckboxesColumn1}
          referenceCheckboxesColumn2={referenceCheckboxesColumn2}
          referenceCheckboxesColumn3={referenceCheckboxesColumn3}
        />
      ),
      free_comment: () => (
        <FreeCommentForm
          comment={comment}
          handleFreeCommentInputChange={handleFreeCommentInputChange}
        />
      ),
      pricing_calculator: () => (
        <PricingCalculator
          budget={budget}
          minBudget={minBudget}
          maxBudget={maxBudget}
          recommendedBudget={recommendedBudget}
          onBudgetChange={handleBudgetChange}
          onPricingCalculatorMounted={onPricingCalculatorMounted}
        />
      ),
      managed_marketplace: () => (
        <ManagementWay
          handleGoToSection={handleGoToSection}
          handleSaveManagementWay={handleSaveManagementWay}
          handleNextStep={handleNextStep}
        />
      ),
      management_way: () => (
        <ContactOption
          handleNextStep={handleNextStep}
          handleAddContactInfo={handleAddContactInfo}
          phone_number_ddi="+1"
          {...selectedValue[0]}
          {...selectedValue[1]}
        />
      ),
      freelancer_chooser: () => (
        <FreelancerChooser
          projectId={projectId}
          freelancers={freelancers}
          pagination={freelancersPagination}
          handleFetchFreelancers={handleFetchFreelancers}
          handleBookNow={handleFreelancerBookNow}
          handleRequestABid={handleFreelancerRequestABid}
          handleDeleteABid={handleFreelancerDeleteABid}
          handleShowChooserPopup={handleShowFreelancerChooserPopup}
          handleFreelancerCardClicked={handleFreelancerCardClicked}
          isFetchingFreelancers={isFetchingFreelancers}
        />
      ),
      summary: () => <Summary handleGoToDashboard={handleGoToDashboard} />,
    };
    return specialCards[card]();
  }

  requestCardInputFocus = (selectedValue, isSavingProject) => {
    if (
      this.cardInput &&
      this.cardInput.current &&
      selectedValue.includes('other') &&
      !isSavingProject
    ) {
      this.cardInput.current.focus();
    }
  };

  handleInputChange = _.debounce((cardInfo, cardInput) => {
    this.props.handleCardSelected(
      new Event('change'),
      cardInfo,
      null,
      cardInput,
    );
  }, 600);

  renderOnboardingCard(handleCardSelected) {
    const {
      cardInfo,
      selectedValue,
      handleCardInputChange,
      isSavingProject,
      isBasicRequirement,
      isVideoFormat,
    } = this.props;

    this.requestCardInputFocus(selectedValue, isSavingProject);

    const isDropbox = cardInfo.value === 'dropbox';
    const showCardIcon = !cardInfo.noIcon && !cardInfo.isTextMiddle;

    return (
      <div
        className={classNames('card-dash shadow-cs', {
          'card-dash-4': isBasicRequirement || isVideoFormat,
          'card-dash-3': !isBasicRequirement && !isVideoFormat,
          'card-dash-6 mb-4': !isDropbox,
          'card-dash-12': isDropbox,
          'active active-dash':
            selectedValue.length > 0 && selectedValue.includes(cardInfo.value),
          'card-dash-no-icon': cardInfo.noIcon,
        })}
        onClick={event =>
          _.isFunction(handleCardSelected)
            ? handleCardSelected(event, cardInfo, null, this.cardInput)
            : () => {}
        }
      >
        <div
          className={classNames('card-dash-inner', cardInfo.value, {
            'active border-primary':
              selectedValue.length > 0 &&
              selectedValue.includes(cardInfo.value),
            'onboarding-card-wide_image': cardInfo.wideImage,
            'onboarding-card-no_icon': cardInfo.noIcon,
          })}
        >
          {cardInfo.is_hand && <div className="onboarding-card__icon" />}
          {showCardIcon && (
            <div
              className={`onboarding-card__image onboarding-card__image--${
                cardInfo.value
              } ${cardInfo.wideImage ? 'wide-image img-top' : ''}`}
            />
          )}
          <div className="text-center card-title-el">
            <div
              className={classNames('card-title', {
                'mb-0': cardInfo.noIcon || cardInfo.wideImage,
              })}
            >
              {cardInfo.label}
            </div>
            {cardInfo.boldLabel && (
              <div className="card-title">{cardInfo.boldLabel}</div>
            )}
            {cardInfo.text && (
              <div className="card-description">{cardInfo.text}</div>
            )}
            {cardInfo.containInput && (
              <div className="onboarding-card__input-field px-3">
                <div className="ui input login__content-input">
                  <Input
                    type="text"
                    name=""
                    disabled={isSavingProject}
                    onChange={event => {
                      handleCardInputChange(event, cardInfo.value);
                      this.handleInputChange(cardInfo, this.cardInput);
                    }}
                    value={cardInfo.inputValue}
                    className="login__content-input"
                    maxLength={200}
                    ref={this.cardInput}
                    placeholder={cardInfo.placeholder}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

OnboardingCard.propTypes = {
  cardInfo: PropTypes.object,
  handleCardSelected: PropTypes.func,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  handleCardInputChange: PropTypes.func,
  references: PropTypes.array,
  handleAddReference: PropTypes.func,
  handleDeleteReference: PropTypes.func,
  handleProjectBriefInput: PropTypes.func,
  projectId: PropTypes.number,
  projectName: PropTypes.string,
  projectBrief: PropTypes.string,
  projectPicture: PropTypes.string,
  projectAttachments: PropTypes.array,
  handleReferenceInputChange: PropTypes.func,
  handleProjectUpload: PropTypes.func,
  handleRemoveUpload: PropTypes.func,
  isUploadingAttachment: PropTypes.bool,
  isUploadingProjectPicture: PropTypes.bool,
  isSavingProject: PropTypes.bool,
  budget: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minBudget: PropTypes.number,
  maxBudget: PropTypes.number,
  recommendedBudget: PropTypes.number,
  handleBudgetChange: PropTypes.func,
  onPricingCalculatorMounted: PropTypes.func,
  freelancers: PropTypes.array,
  freelancersPagination: PropTypes.object,
  handleFetchFreelancers: PropTypes.func,
  handleFreelancerBookNow: PropTypes.func,
  handleFreelancerRequestABid: PropTypes.func,
  handleFreelancerDeleteABid: PropTypes.func,
  isFetchingFreelancers: PropTypes.bool,
  handleShowFreelancerChooserPopup: PropTypes.func,
  handleFreelancerCardClicked: PropTypes.func,
  handleAddDeadline: PropTypes.func,
  deadline: PropTypes.instanceOf(moment),
  handleNextStep: PropTypes.func,
  isBasicRequirement: PropTypes.bool,
  isVideoFormat: PropTypes.bool,
  handleGoToSection: PropTypes.func,
  handleAddContactInfo: PropTypes.func,
  handleSaveManagementWay: PropTypes.func,
  handleGoToDashboard: PropTypes.func,
  handleFreeCommentInputChange: PropTypes.func,
  comment: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/OnboardingCard/OnboardingCard.js